import React from "react";

import MuiIconButton, {
  IconButtonProps as MuiIconButtonProps,
} from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";

import { lightOrDark } from "@app/embedded/theme/utils";

export type IconButtonProps = MuiIconButtonProps & {
  variant?: "outlined" | "text";
};

const StyledButton = styled<React.FC<IconButtonProps>>(
  ({ variant: _v, ...props }) => <MuiIconButton {...props} />
)(({ theme, variant }) => ({
  borderRadius: "4px",
  transition: "all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
  ...(variant === "outlined" && {
    border: "1px solid",
    borderColor: theme.palette.transparent.black[8],
  }),
  "& .MuiSvgIcon-root": {
    color: lightOrDark(
      theme.palette.shades.neutral[500],
      theme.palette.shades.neutral[200]
    )(theme),
  },
  "&:hover, &.focused": {
    backgroundColor: lightOrDark(
      theme.palette.shades.primary[50],
      theme.palette.shades.neutral[700]
    )(theme),
    "& .MuiSvgIcon-root": {
      color: lightOrDark(
        theme.palette.shades.primary[500],
        theme.palette.shades.neutral[100]
      )(theme),
    },
    color: lightOrDark(
      theme.palette.shades.primary[500],
      theme.palette.shades.neutral[100]
    )(theme),
    ...(variant === "outlined" && {
      borderColor: theme.palette.shades.primary[500],
    }),
  },
}));

const IconButton = ({ variant = "text", ...props }: IconButtonProps) => {
  return <StyledButton disableRipple variant={variant} {...props} />;
};

export default IconButton;
